import { render } from "./projectInfos.vue?vue&type=template&id=65357213&scoped=true"
import script from "./projectInfos.vue?vue&type=script&lang=js"
export * from "./projectInfos.vue?vue&type=script&lang=js"

import "./projectInfos.vue?vue&type=style&index=0&id=65357213&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65357213"]])

export default __exports__